function LoginStepHeader({ eyebrow, heading, subtext }) {
	return (
		<>
			<p className="login-eyebrow">{eyebrow}</p>
			<h1 className="login-heading">{heading}</h1>
			{subtext ? <p className="login-subtext">{subtext}</p> : null}
		</>
	);
}

export default LoginStepHeader;
